import { fromJS } from 'immutable';
import Actions from 'flow/actions';
import { listToMap } from 'flow/utils';

export const initialState = fromJS({
    operators: [],
    byKey: {},
});

const operatorReducer = (state = initialState, action) => {
    switch (action ? action.type : null) {
        case Actions.CLEAR_STATE:
            return initialState;
        case Actions.RESULT_OPERATOR_OPERATORS: {
            const operatorsList = fromJS(action.operators);
            const operatorsMap = listToMap(operatorsList, (item) =>
                item.get('key'),
            );
            return state
                .set('operators', operatorsList)
                .mergeDeepIn(['byKey'], operatorsMap);
        }
        case Actions.RESULT_OPERATOR_DATA: {
            const { data } = action;
            const { key } = data;
            if (key) {
                return state.setIn(['byKey', key], fromJS(data));
            }
            return state;
        }
        default:
            return state;
    }
};

export default operatorReducer;
